/** @format */

import { useContext } from 'react';
import { ActionContext } from 'providers';

function useAction() {
  return useContext(ActionContext);
}

export { useAction };
